function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

import React from "react";
import { Button, FilterListIcon, NotificationBadge } from "@catchoftheday/cg-components";
import { useActions, useShallowSelector } from "@search-app/store";
import { searchFacetsVisiblity } from "@search-app/store/search/actions";
import { isSearchLoading } from "@search-app/store/search/selectors";
import { jsx as ___EmotionJSX } from "@emotion/react";

var _ref2 = true ? {
  name: "1693thf",
  styles: "margin-right:5px"
} : {
  name: "4zl2o7-SearchFacetsToggle",
  styles: "margin-right:5px;label:SearchFacetsToggle;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};

export var SearchFacetsToggle = function SearchFacetsToggle(_ref) {
  var totalFacetsApplied = _ref.totalFacetsApplied;

  var _useReduxState = useReduxState(),
      isDisabled = _useReduxState.isDisabled;

  var _useReduxActions = useReduxActions(),
      toggleFacetsModal = _useReduxActions.toggleFacetsModal;

  return ___EmotionJSX(Button, {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "100%",
    p: "0",
    sizeVariant: "sm",
    textTransform: "none",
    variant: "plain",
    disabled: isDisabled,
    onClick: toggleFacetsModal,
    fontSize: "base"
  }, ___EmotionJSX(FilterListIcon, {
    css: _ref2
  }), " Filters", !!totalFacetsApplied && ___EmotionJSX(NotificationBadge, {
    text: totalFacetsApplied,
    position: "relative",
    display: "inline-block",
    absTop: "0",
    backgroundColor: "secondary"
  }));
};

var useReduxState = function useReduxState() {
  return useShallowSelector(function (state) {
    return {
      isDisabled: isSearchLoading(state)
    };
  });
};

var useReduxActions = function useReduxActions() {
  return useActions({
    toggleFacetsModal: function toggleFacetsModal() {
      return searchFacetsVisiblity();
    }
  });
};